function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

import React from "react";
import { Button, FilterListIcon, NotificationBadge } from "@catchoftheday/cg-components";
import { useActions, useShallowSelector } from "@search-app/store";
import { searchFacetsVisiblity } from "@search-app/store/search/actions";
import { isSearchLoading } from "@search-app/store/search/selectors";
import { jsx as ___EmotionJSX } from "@emotion/react";

var _ref2 = true ? {
  name: "1693thf",
  styles: "margin-right:5px"
} : {
  name: "4zl2o7-SearchFacetsToggle",
  styles: "margin-right:5px;label:SearchFacetsToggle;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};

export var SearchFacetsToggle = function SearchFacetsToggle(_ref) {
  var totalFacetsApplied = _ref.totalFacetsApplied;

  var _useReduxState = useReduxState(),
      isDisabled = _useReduxState.isDisabled;

  var _useReduxActions = useReduxActions(),
      toggleFacetsModal = _useReduxActions.toggleFacetsModal;

  return ___EmotionJSX(Button, {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "100%",
    p: "0",
    sizeVariant: "sm",
    textTransform: "none",
    variant: "plain",
    disabled: isDisabled,
    onClick: toggleFacetsModal,
    fontSize: "base"
  }, ___EmotionJSX(FilterListIcon, {
    css: _ref2
  }), " Filters", !!totalFacetsApplied && ___EmotionJSX(NotificationBadge, {
    text: totalFacetsApplied,
    position: "relative",
    display: "inline-block",
    absTop: "0",
    backgroundColor: "secondary"
  }));
};

var useReduxState = function useReduxState() {
  return useShallowSelector(function (state) {
    return {
      isDisabled: isSearchLoading(state)
    };
  });
};

var useReduxActions = function useReduxActions() {
  return useActions({
    toggleFacetsModal: function toggleFacetsModal() {
      return searchFacetsVisiblity();
    }
  });
};